export class TabClusterModel {
  idAclrr: number
  idArea: number
  idCluster: number
  idClusterComuni: number
  idComune: string
  idLottoGara: number
}